import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ColorModeContext, useMode } from "./theme";
import { CssBaseline, ThemeProvider, Box } from "@mui/material";
import MandiReportForm from "./Components/WebApp/Mandireportform";
import config from "./config";

const AUTH_TOKEN_STORAGE_KEY = "token";

async function getFormWebToken() {
  const existingToken = sessionStorage.getItem(AUTH_TOKEN_STORAGE_KEY);

  if (existingToken) {
    return existingToken;
  }

  const response = await fetch(
    `${config.apiBaseUrl}/auth/form-web-token`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }
  );

  let data;

  try {
    data = await response.json();
  } catch {
    throw new Error("Invalid authentication response");
  }

  if (!response.ok || !data?.success || !data?.token) {
    throw new Error(
      data?.message || "Failed to get authentication token"
    );
  }

  sessionStorage.setItem(AUTH_TOKEN_STORAGE_KEY, data.token);

  return data.token;
}

function App() {
  const [theme, colorMode] = useMode();
  const [authLoading, setAuthLoading] = useState(true);
  const [authError, setAuthError] = useState("");

  useEffect(() => {
    let mounted = true;

    const initializeAuth = async () => {
      try {
        setAuthLoading(true);
        setAuthError("");

        await getFormWebToken();
      } catch (error) {
        console.error("Form Web authentication error:", error);

        if (mounted) {
          sessionStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
          setAuthError(
            error?.message ||
              "Authentication failed. Please refresh the page."
          );
        }
      } finally {
        if (mounted) {
          setAuthLoading(false);
        }
      }
    };

    initializeAuth();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        {authLoading ? (
          <Box
            sx={{
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 16,
            }}
          >
            Loading...
          </Box>
        ) : authError ? (
          <Box
            sx={{
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              padding: 3,
            }}
          >
            {authError}
          </Box>
        ) : (
          <Router>
            <Box>
              <Routes>
                <Route
                  path="/"
                  element={<MandiReportForm />}
                />
              </Routes>
            </Box>
          </Router>
        )}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;